import { useCallback, createContext, useContext } from 'react'
import { QUERY_GET_CONTENT_BY_SLUG } from 'shop/client'
import { AppContentQueryResponse } from './types'
import { useShop } from './useShop'

type LoaderState = {
  fetchAppContent: () => Promise<AppContentQueryResponse | null>
}

export const SetupLoader = (): LoaderState => {
  const { useShopClient, config } = useShop()

  const { domain: merchantSlug } = config
  const client = useShopClient()

  const fetchAppContent = useCallback(async () => {
    if (!merchantSlug || !client) {
      return null
    }

    try {
      const result = await client.query({
        query: QUERY_GET_CONTENT_BY_SLUG,
        variables: {
          merchantSlug: merchantSlug
        }
      })

      const appContent = result?.data?.getContent

      if (!appContent) {
        return null
      }

      return appContent
    } catch {
      return null
    }

    // [client] causes endless api calls
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantSlug])

  return {
    fetchAppContent
  }
}

const defaultResponse = () => new Promise<null>((resolve) => resolve(null))

const initialState: LoaderState = {
  fetchAppContent: defaultResponse
}

export const LoaderContext = createContext<LoaderState>(initialState)

export const useLoader = () => {
  return useContext(LoaderContext)
}
